import * as React from 'react';

export const jpFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_402)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_402'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_402)'>
                <path
                    d='M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 10C18.6667 7.42268 16.5773 5.33334 14 5.33334C11.4227 5.33334 9.33333 7.42268 9.33333 10C9.33333 12.5773 11.4227 14.6667 14 14.6667Z'
                    fill='#BD0029'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_402'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
